module['exports'] = function(colors) {
  return function(letter, i, exploded) {
    return i % 2 === 0 ? letter : colors.inverse(letter);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/colors/lib/maps/zebra.js
// module id = 2217
// module chunks = 0 1